import { ChangeEvent, useEffect, useRef, useState } from 'react';
import './filter.css';
import { IQueryParams } from '../../types/type';

export interface FilterProps {
  filter: { query: string; filterQuery: string } | undefined;
  setFilter: ((filter: { query: string; filterQuery: string }) => void) | undefined;
  params?: IQueryParams[];
}

function Filter({ filter = undefined, setFilter = undefined, params }: FilterProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const placeholderMap: Record<string, string> = {
    firstName: 'имени',
    name: 'имени',
    middleName: 'отчеству',
    lastName: 'фамилии',
    phone: 'номеру телефона',
    login: 'логину',
    birthDay: 'дате рождения',
    date: 'дате',
    gosNumber: 'гос. номеру',
    mark: 'марке авто',
    model: 'модели авто',
    role: 'роли',
  };

  const placeholderText = placeholderMap[filter?.filterQuery || ''] || '';

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (setFilter && filter) {
      setFilter({ ...filter, query: e.target.value });
    }
  };

  const handleSortSelect = (sort: string) => {
    if (setFilter && filter) {
      setFilter({ ...filter, filterQuery: sort });
      setIsDropdownOpen(false);
    }
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    if (location.pathname === '/account/admin/users' && inputRef.current) {
      inputRef.current.focus();
    }
  }, [location]);

  return (
    <div className="search-bar" onMouseLeave={() => setIsDropdownOpen(false)}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M22 22L20 20" stroke="#3D5278" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <input
        ref={inputRef}
        type="text"
        placeholder={`Поиск пользователей по ${placeholderText}`}
        value={filter?.query || ''}
        autoComplete="off"
        onChange={handleInputChange}
      />
      <svg
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setIsDropdownOpen(true)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 6.5H16"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6.5H2"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10C11.933 10 13.5 8.433 13.5 6.5C13.5 4.567 11.933 3 10 3C8.067 3 6.5 4.567 6.5 6.5C6.5 8.433 8.067 10 10 10Z"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 17.5H18"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 17.5H2"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 21C15.933 21 17.5 19.433 17.5 17.5C17.5 15.567 15.933 14 14 14C12.067 14 10.5 15.567 10.5 17.5C10.5 19.433 12.067 21 14 21Z"
          stroke="#3D5278"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {isDropdownOpen && (
        <div className="dropdown-search__wrapper">
          <div className="dropdown-search__container" onMouseLeave={() => setIsDropdownOpen(false)}>
            <div className="dropdown-search">
              {params ? (
                params.map((param, index) => (
                  <label
                    className={`dropdown-item ${filter?.filterQuery === param.i_value ? 'dropdown-item__active' : ''}`}
                    key={index}
                    onClick={() => handleSortSelect(param.i_value)}
                  >
                    <input id={param.i_id} name={param.i_name} type={param.i_type} value={param.i_value} />
                    {param.i_label}
                  </label>
                ))
              ) : (
                <>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'lastName' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('lastName')}
                  >
                    <input type="radio" name="filterType" value="lastName" />
                    Фамилия
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'name' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('name')}
                  >
                    <input type="radio" name="filterType" value="name" />
                    Имя
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'middleName' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('middleName')}
                  >
                    <input type="radio" name="filterType" value="middleName" />
                    Отчество
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'firstName' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('firstName')}
                  >
                    <input type="radio" name="filterType" value="firstName" />
                    Имя и отчество
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'login' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('login')}
                  >
                    <input type="radio" name="filterType" value="login" />
                    Логин
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'phone' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('phone')}
                  >
                    <input type="radio" name="filterType" value="phone" />
                    Телефон
                  </label>
                  <label
                    className={`dropdown-item ${filter?.filterQuery === 'role' ? 'dropdown-item__active' : ''}`}
                    onClick={() => handleSortSelect('role')}
                  >
                    <input type="radio" name="filterType" value="role" />
                    Роль
                  </label>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Filter;
